module.exports = __webpack_public_path__ + "static/assets/greeting_permission.png";